<template>
  <a-modal
    :visible="visible"
    :destroy-on-close="true"
    @cancel="$emit('close')"
    @ok="handleStoreKnowledgeDomain"
  >
    <h3>Create a new knowledge domain</h3>

    <a-form layout="horizontal">
      <a-form-item
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        :validate-status="errors.first('title') ? 'error' : ''"
        :help="errors.first('title')"
        label="Title"
      >
        <a-input
          v-model="newKnowledgeDomain.title"
          v-validate="'required|max:255'"
          placeholder="Knowledge domain title"
          data-vv-name="title"
        />
      </a-form-item>

      <a-form-item
        :colon="false"
        :validate-status="errors.first('description_productive') ? 'error' : ''"
        :help="errors.first('description_productive')"
        label="Productive"
      >
        <a-textarea
          v-model="newKnowledgeDomain.description_productive"
          v-validate="'required'"
          :auto-size="{ minRows: 3 }"
          data-vv-name="description_productive"
          data-vv-as="productive description"
          placeholder="Description for Productive"
        />
      </a-form-item>

      <a-form-item :colon="false" label="Advanced">
        <a-textarea
          v-model="newKnowledgeDomain.description_advanced"
          :auto-size="{ minRows: 3 }"
          placeholder="Description for Advanced"
        />
      </a-form-item>

      <a-form-item :colon="false" label="Expert">
        <a-textarea
          v-model="newKnowledgeDomain.description_expert"
          :auto-size="{ minRows: 3 }"
          placeholder="Description for Expert"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, watch, getCurrentInstance } from "vue";
import useMixin from "@/useMixin";

// Props
const props = defineProps({
  visible: { type: Boolean, default: false },
});

// Emits
const emits = defineEmits(["store-knowledge-domain", "close"]);

// Mixins
const { setObject } = useMixin();

const newKnowledgeDomain = ref<any>({
  title: undefined,
  description_productive: undefined,
  description_advanced: undefined,
  description_expert: undefined,
});

// Watchers
watch(
  () => props.visible,
  (newProp, oldProp) => {
    if (newProp && !oldProp) {
      newKnowledgeDomain.value = setObject(newKnowledgeDomain.value, undefined);
    }
  }
);

// Class Methods
const instance = getCurrentInstance();
const $validator = instance?.proxy.$validator;
const handleStoreKnowledgeDomain = (): void => {
  $validator?.validateAll().then((result) => {
    if (result) {
      emits("store-knowledge-domain", newKnowledgeDomain.value);
      emits("close");
    }
  });
};
</script>
